// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__13W8t","signatureBlock":"Footer_signatureBlock__1VeSg","signature":"Footer_signature__27NtO"};